class TabList extends HTMLUListElement {
    constructor() {
        super(), this.controls.forEach((t => t.addEventListener("click", this.handleButtonClick.bind(this))))
    }
    get controls() {
        return this._controls = this._controls || Array.from(this.querySelectorAll("[aria-controls]"))
    }
    handleButtonClick(t) {
        t.preventDefault(), this.controls.forEach((t => {
            t.setAttribute("aria-expanded", "false");
            const e = document.getElementById(t.getAttribute("aria-controls"));
            e?.removeAttribute("open")
        }));
        const e = t.currentTarget;
        e.setAttribute("aria-expanded", "true");
        const n = document.getElementById(e.getAttribute("aria-controls"));
        n?.setAttribute("open", "")
    }
    reset() {
        this.controls[0].dispatchEvent(new Event("click"))
    }
}
customElements.define("tab-list", TabList, {
    extends: "ul"
});
class CartDrawer extends DrawerElement {
    constructor() {
        super()
    }
    get shouldAppendToBody() {
        return !1
    }
    get recentlyViewed() {
        return this.querySelector("recently-viewed")
    }
    get tabList() {
        return this.querySelector('[is="tab-list"]')
    }
    connectedCallback() {
        super.connectedCallback(), document.addEventListener("cart:bundled-sections", this.onPrepareBundledSections.bind(this)), this.recentlyViewed && this.recentlyViewed.addEventListener("is-empty", this.onRecentlyViewedEmpty.bind(this))
    }
    onPrepareBundledSections(t) {
        t.detail.sections.push(theme.utils.sectionId(this))
    }
    onRecentlyViewedEmpty() {
        this.recentlyViewed.innerHTML = `\n    <div class="drawer__scrollable relative flex justify-center items-start grow shrink text-center">\n      <div class="drawer__empty grid gap-5 md:gap-8">\n        <h2 class="drawer__empty-text font-bold leading-none tracking-tight">${theme.strings.recentlyViewedEmpty}</h2>\n      </div>\n    </div>\n    `
    }
    show(t = null, e = !0) {
        super.show(t, e), this.tabList && (this.tabList.reset(), this.open && theme.a11y.trapFocus(this, this.focusElement))
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartQuantity extends QuantitySelector {
    constructor() {
        super()
    }
    quantityUpdateUnsubscriber = void 0;
    connectedCallback() {
        super.connectedCallback(), this.quantityUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber()
    }
    validateQtyRules() {
        const t = parseInt(this.input.value);
        if (this.input.min) {
            const e = this.querySelector('[name="minus"]');
            e && (e.disabled = parseInt(t) <= parseInt(this.input.min))
        }
        if (this.input.max) {
            const e = this.querySelector('[name="plus"]');
            e && (e.disabled = parseInt(t) >= parseInt(this.input.max))
        }
    }
}
customElements.define("cart-quantity", CartQuantity);
class CartRemoveButton extends HTMLAnchorElement {
    constructor() {
        super(), this.addEventListener("click", (t => {
            t.preventDefault();
            this.closest("cart-items").updateQuantity(this.dataset.index, 0)
        }))
    }
}
customElements.define("cart-remove-button", CartRemoveButton, {
    extends: "a"
});
class CartItems extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", theme.utils.debounce(this.onChange.bind(this), 300)), this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this))
    }
    cartUpdateUnsubscriber = void 0;
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
    }
    onChange(t) {
        this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"), t.target)
    }
    onCartUpdate(t) {
        if (t.cart.errors) return void this.onCartError(t.cart.errors, t.target);
        const e = theme.utils.sectionId(this),
            n = (new DOMParser).parseFromString(t.cart.sections[e], "text/html"),
            s = document.querySelector(`#MiniCart-${e}`);
        if (s) {
            const t = n.querySelector(`#MiniCart-${e}`);
            t && (s.innerHTML = t.innerHTML)
        }
        const r = document.querySelector(`#MainCart-${e}`);
        if (r) {
            const t = n.querySelector(`#MainCart-${e}`);
            t ? r.innerHTML = t.innerHTML : (r.closest(".cart").classList.add("is-empty"), r.remove())
        }
        const i = document.getElementById(`CartItem-${t.line}`) || document.getElementById(`CartDrawer-Item-${t.line}`);
        i && i.querySelector(`[name="${t.name}"]`) ? theme.a11y.trapFocus(r || s, i.querySelector(`[name="${t.name}"]`)) : 0 === t.cart.item_count ? s ? theme.a11y.trapFocus(s, s.querySelector("a")) : theme.a11y.trapFocus(document.querySelector(".empty-state"), document.querySelector(".empty-state__link")) : s ? theme.a11y.trapFocus(s, s.querySelector(".horizontal-product__title")) : theme.a11y.trapFocus(r, r.querySelector(".cart__item-title")), document.dispatchEvent(new CustomEvent("cart:updated", {
            detail: {
                cart: t.cart
            }
        }))
    }
    onCartError(t, e) {
        e ? this.updateQuantity(e.dataset.index, e.defaultValue, document.activeElement.getAttribute("name"), e) : window.location.href = theme.routes.cart_url, alert(t)
    }
    updateQuantity(t, e, n, s) {
        this.enableLoading(t);
        let r = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:bundled-sections", {
            bubbles: !0,
            detail: {
                sections: r
            }
        }));
        const i = JSON.stringify({
            line: t,
            quantity: e,
            sections: r
        });
        fetch(`${theme.routes.cart_change_url}`, {
            ...theme.utils.fetchConfig(),
            body: i
        }).then((t => t.json())).then((e => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                cart: e,
                target: s,
                line: t,
                name: n
            })
        })).catch((t => {
            console.log(t)
        }))
    }
    enableLoading(t) {
        const e = theme.utils.sectionId(this),
            n = document.getElementById(`Loader-${e}-${t}`);
        n && (n.hidden = !1)
    }
}
customElements.define("cart-items", CartItems);
class CartNote extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", theme.utils.debounce(this.onChange.bind(this), 300))
    }
    onChange(t) {
        const e = JSON.stringify({
            note: t.target.value
        });
        fetch(`${theme.routes.cart_update_url}`, {
            ...theme.utils.fetchConfig(),
            body: e
        })
    }
}
customElements.define("cart-note", CartNote);
class MainCart extends HTMLElement {
    constructor() {
        super(), document.addEventListener("cart:bundled-sections", this.onPrepareBundledSections.bind(this))
    }
    onPrepareBundledSections(t) {
        t.detail.sections.push(theme.utils.sectionId(this))
    }
}
customElements.define("main-cart", MainCart);
class CountryProvince extends HTMLElement {
    constructor() {
        super(), this.provinceElement = this.querySelector('[name="address[province]"]'), this.countryElement = this.querySelector('[name="address[country]"]'), this.countryElement.addEventListener("change", this.handleCountryChange.bind(this)), "" !== this.getAttribute("country") ? (this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((t => t.textContent === this.dataset.country))), this.countryElement.dispatchEvent(new Event("change"))) : this.handleCountryChange()
    }
    handleCountryChange() {
        const t = this.countryElement.options[this.countryElement.selectedIndex],
            e = JSON.parse(t.dataset.provinces);
        this.provinceElement.parentElement.hidden = 0 === e.length, 0 !== e.length && (this.provinceElement.innerHTML = "", e.forEach((t => {
            const e = t[1] === this.dataset.province;
            this.provinceElement.options.add(new Option(t[1], t[0], e, e))
        })))
    }
}
customElements.define("country-province", CountryProvince);
class ShippingCalculator extends HTMLFormElement {
    constructor() {
        super(), this.submitButton = this.querySelector('[type="submit"]'), this.resultsElement = this.lastElementChild, this.submitButton.addEventListener("click", this.handleFormSubmit.bind(this))
    }
    handleFormSubmit(t) {
        t.preventDefault();
        const e = this.querySelector('[name="address[zip]"]').value,
            n = this.querySelector('[name="address[country]"]').value,
            s = this.querySelector('[name="address[province]"]').value;
        this.submitButton.setAttribute("aria-busy", "true");
        const r = JSON.stringify({
            shipping_address: {
                zip: e,
                country: n,
                province: s
            }
        });
        let i = `${theme.routes.cart_url}/shipping_rates.json`;
        i = i.replace("//", "/"), fetch(i, {
            ...theme.utils.fetchConfig("javascript"),
            body: r
        }).then((t => t.json())).then((t => {
            t.shipping_rates ? this.formatShippingRates(t.shipping_rates) : this.formatError(t)
        })).catch((t => {
            console.error(t)
        })).finally((() => {
            this.resultsElement.hidden = !1, this.submitButton.removeAttribute("aria-busy")
        }))
    }
    formatError(t) {
        const e = Object.keys(t).map((e => `<li>${t[e]}</li>`));
        this.resultsElement.innerHTML = `\n      <div class="alert alert--error grid gap-2 text-sm leading-tight">\n        <p>${theme.shippingCalculatorStrings.error}</p>\n        <ul class="list-disc grid gap-2" role="list">${e.join("")}</ul>\n      </div>\n    `
    }
    formatShippingRates(t) {
        const e = t.map((({
            presentment_name: t,
            currency: e,
            price: n
        }) => `<li>${t}: ${e} ${n}</li>`));
        this.resultsElement.innerHTML = `\n      <div class="alert alert--${0===t.length?"error":"success"} grid gap-2 text-sm leading-tight">\n        <p>${0===t.length?theme.shippingCalculatorStrings.notFound:1===t.length?theme.shippingCalculatorStrings.oneResult:theme.shippingCalculatorStrings.multipleResults}</p>\n        ${""===e?"":`<ul class="list-disc grid gap-2" role="list">${e.join("")}</ul>`}\n      </div>\n    `
    }
}
customElements.define("shipping-calculator", ShippingCalculator, {
    extends: "form"
});